export default {
  nav: {
    home: 'होम',
    about: 'हमारे बारे में',
    programs: 'हमारे कार्यक्रम',
    gallery: 'गैलरी',
    news: 'समाचार और कार्यक्रम',
    contact: 'संपर्क करें',
    donate: 'अभी दान करें',
  },
  brand: { name: 'हिन्द क्रांति सेना', sub: 'फाउंडेशन' },
  common: { comingSoon: 'जल्द आ रहा है', donateDisabledTitle: 'ऑनलाइन दान जल्द शुरू हो रहा है' },
  footer: {
    about: 'एक भारतीय गैर-लाभकारी संस्था जो महिला सुरक्षा और सशक्तिकरण, पशु कल्याण, पर्यावरण संरक्षण तथा स्वच्छ, स्वस्थ समुदायों के लिए कार्यरत है।',
    quickLinks: 'त्वरित लिंक',
    focusAreas: 'कार्यक्षेत्र',
    getInTouch: 'संपर्क करें',
    address: 'रायपुर, छत्तीसगढ़',
    copyright: 'हिन्द क्रांति सेना फाउंडेशन. सर्वाधिकार सुरक्षित.',
    privacy: 'गोपनीयता नीति',
  },
  home: {
    hero: {
      eyebrow: 'राष्ट्रीय हिन्द क्रांति सेना फाउंडेशन',
      title: 'महिलाओं, पशुओं और हमारे साझा पर्यावरण के लिए खड़े होना।',
      subtitle: 'एक जमीनी भारतीय गैर-लाभकारी संस्था जो महिला सुरक्षा एवं सशक्तिकरण, पशु कल्याण, पर्यावरण संरक्षण और स्वच्छ, स्वस्थ समुदायों के लिए काम करती है — एक-एक मोहल्ले से शुरुआत करते हुए।',
      volunteer: 'स्वयंसेवक बनें',
    },
    stats: {
      volunteers: 'जुड़े हुए स्वयंसेवक',
      localities: 'गांव और क्षेत्र जहाँ पहुंचे',
      trees: 'लगाए गए पेड़',
      focus: 'कार्यक्षेत्र, एक लक्ष्य',
    },
    pillars: {
      eyebrow: 'हम क्या करते हैं',
      title: 'चार स्तंभ, एक लक्ष्य',
      subtitle: 'हमारा हर कार्य इन आपस में जुड़े उद्देश्यों के अंतर्गत आता है।',
      learnMore: 'और जानें',
      women: { title: 'महिला सुरक्षा और सशक्तिकरण', text: 'महिलाओं और लड़कियों के लिए वकालत, पीड़ित सहायता और कौशल-विकास।' },
      animals: { title: 'पशु कल्याण', text: 'सड़क और अनाथ पशुओं के लिए बचाव, उपचार और गोद लेने के अभियान।' },
      environment: { title: 'पर्यावरण संरक्षण', text: 'वृक्षारोपण, जैव विविधता और समुदाय-आधारित स्थिरता।' },
      clean: { title: 'स्वच्छ समुदाय', text: 'स्वच्छता अभियान और कूड़ा-मुक्त, स्वस्थ सार्वजनिक स्थान।' },
    },
    about: {
      eyebrow: 'हम कौन हैं',
      title: 'समुदाय-नेतृत्व वाला, टिकाऊ बदलाव',
      text: 'हिन्द क्रांति सेना फाउंडेशन स्वयंसेवकों, स्थानीय नेताओं और साझेदार संस्थाओं को एक साथ लाकर लैंगिक हिंसा को चुनौती देता है, असहाय पशुओं की रक्षा करता है, हरियाली बहाल करता है और हमारे शहरों व गांवों को स्वच्छ रखता है। हमारा मानना है कि स्थायी बदलाव समुदायों के साथ मिलकर बनाया जाता है, ऊपर से थोपा नहीं जाता।',
      cta: 'हमारे बारे में और जानें',
      valuesTitle: 'हमारे मूल्य',
      v1: 'हर कार्य में करुणा',
      v2: 'समुदाय-प्रथम निर्णय',
      v3: 'पारदर्शिता और जवाबदेही',
      v4: 'टिकाऊ, दीर्घकालिक प्रभाव',
    },
    involve: {
      eyebrow: 'जुड़ें',
      title: 'आज ही मदद करने के तीन तरीके',
      donateTitle: 'दान करें',
      donateText: 'बचाव अभियानों, वृक्षारोपण और संकट में महिलाओं की सहायता के लिए धन दें।',
      volunteerTitle: 'स्वयंसेवक बनें',
      volunteerText: 'अपने क्षेत्र में सफाई अभियान, बचाव दल या सामुदायिक पहुंच में शामिल हों।',
      volunteerBtn: 'जुड़ें',
      partnerTitle: 'हमारे साथ साझेदारी करें',
      partnerText: 'कॉर्पोरेट, एनजीओ और सामुदायिक समूह — आइए मिलकर असर डालें।',
      partnerBtn: 'संपर्क करें',
    },
    cta: {
      title: 'एक सुरक्षित, हरित भारत के आंदोलन से जुड़ें',
      text: 'आपका हर रुपया, हर घंटा और हर आवाज़ हमें आगे बढ़ने में मदद करती है।',
      programs: 'हमारे कार्यक्रम देखें',
    },
  },
  about: {
    hero: { eyebrow: 'हमारे बारे में', title: 'जमीनी स्तर पर, जनता की शक्ति से बदलाव', subtitle: 'हम कौन हैं, हम किसके लिए खड़े हैं, और हम कैसे काम करते हैं।' },
    mission: { title: 'हमारा लक्ष्य', text: 'लैंगिक हिंसा और असमानता को चुनौती देना, पशुओं को क्रूरता और उपेक्षा से बचाना, हरियाली बहाल करना, और पूरे भारत में स्वच्छ, स्वस्थ समुदाय बनाना — प्रत्यक्ष कार्रवाई, वकालत और सामुदायिक साझेदारी के माध्यम से।' },
    vision: { title: 'हमारी दृष्टि', text: 'एक ऐसा भारत जहाँ महिलाएं और लड़कियां हिंसा से मुक्त जीवन जिएं, पशुओं के साथ करुणा का व्यवहार हो, आने वाली पीढ़ियों के लिए पर्यावरण सुरक्षित रहे, और हर मोहल्ला स्वच्छ व स्वस्थ हो।' },
    approach: {
      eyebrow: 'हमारा दृष्टिकोण',
      title: 'हम कैसे काम करते हैं',
      communityLed: { title: 'समुदाय-नेतृत्व', text: 'हम स्थानीय स्वयंसेवकों और नेताओं को साथ लेकर चलते हैं, उनके इर्द-गिर्द काम नहीं करते।' },
      advocacy: { title: 'वकालत-आधारित', text: 'हम जमीनी राहत के साथ-साथ मजबूत नीति और कानून प्रवर्तन के लिए प्रयासरत हैं।' },
      partnership: { title: 'साझेदारी-प्रथम', text: 'हम एनजीओ, नागरिक निकायों और स्वयंसेवकों के साथ मिलकर आगे बढ़ते हैं।' },
    },
    values: {
      eyebrow: 'मूल मूल्य',
      title: 'हमारे हर निर्णय का आधार',
      compassion: { title: 'करुणा', text: 'लोगों, पशुओं और धरती सबके लिए समान रूप से।' },
      integrity: { title: 'निष्ठा', text: 'हर काम में ईमानदार, पारदर्शी और जवाबदेह।' },
      sustainability: { title: 'स्थिरता', text: 'ऐसे समाधान जो एक अभियान से कहीं आगे तक टिकें।' },
      inclusion: { title: 'समावेशन', text: 'इस मिशन में हर किसी की भूमिका है।' },
    },
    cta: { title: 'क्या आप इस कहानी का हिस्सा बनना चाहते हैं?', text: 'अपना समय, कौशल या सहयोग दें — हर योगदान हमें आगे ले जाता है।', getInvolved: 'जुड़ें' },
  },
  programs: {
    hero: { eyebrow: 'हमारे कार्यक्रम', title: 'जहाँ हमारा काम होता है', subtitle: 'चार कार्यक्षेत्र, हर एक को समर्पित स्वयंसेवकों और साझेदारों का सहयोग।' },
    women: {
      title: 'महिला सुरक्षा और सशक्तिकरण',
      intro: 'लैंगिक हिंसा के खिलाफ वकालत, पीड़ितों के लिए प्रत्यक्ष सहायता, और महिलाओं व लड़कियों की आर्थिक व सामाजिक स्वतंत्रता बनाने वाली कार्यशालाएं।',
      goal1: 'अधिकार, सुरक्षा और समानता पर जागरूकता कार्यशालाएं आयोजित करना',
      goal2: 'पीड़ितों को कानूनी सहायता और परामर्श सहायता से जोड़ना',
      goal3: 'महिलाओं के लिए कौशल-विकास और आजीविका कार्यक्रमों का समर्थन करना',
    },
    animals: {
      title: 'पशु कल्याण और बचाव',
      intro: 'सड़क और अनाथ पशुओं के लिए बचाव व उपचार, नसबंदी अभियान, गोद लेने में सहायता, साथ ही क्रूरता-विरोधी वकालत।',
      goal1: 'घायल या खतरे में पड़े पशुओं के लिए बचाव कॉल का जवाब देना',
      goal2: 'टीकाकरण और नसबंदी शिविरों का समर्थन करना',
      goal3: 'समुदाय में जिम्मेदार गोद लेने की प्रक्रिया को आसान बनाना',
    },
    environment: {
      title: 'पर्यावरण संरक्षण',
      intro: 'वृक्षारोपण अभियान, जैव विविधता जागरूकता, और स्थिरता शिक्षा जिसमें पूरा समुदाय शामिल हो, केवल स्वयंसेवक नहीं।',
      goal1: 'स्थानीय निकायों के सहयोग से नियमित वृक्षारोपण अभियान आयोजित करना',
      goal2: 'देशी प्रजातियों और पेड़ों की दीर्घकालिक देखभाल को बढ़ावा देना',
      goal3: 'स्कूलों में स्थिरता और जलवायु-जागरूकता सत्र आयोजित करना',
    },
    clean: {
      title: 'स्वच्छ और स्वस्थ समुदाय',
      intro: 'सार्वजनिक स्थानों, नालों और जल स्रोतों के लिए कूड़ा-रोकथाम अभियान, स्वच्छता जागरूकता, और सफाई अभियान।',
      goal1: 'मोहल्लों और सार्वजनिक स्थानों में नियमित सफाई अभियान चलाना',
      goal2: 'कचरा पृथक्करण और जिम्मेदार निपटान की आदतों को बढ़ावा देना',
      goal3: 'स्वच्छता अवसंरचना के लिए स्थानीय प्रशासन के साथ साझेदारी करना',
    },
    cta: { title: 'इनमें से किसी कार्यक्रम का समर्थन करना चाहते हैं?', text: "दान करते समय एक कारण चुनें, या हमें बताएं कि आप कहाँ स्वयंसेवा करना चाहेंगे।", volunteer: 'स्वयंसेवक बनें' },
  },
  gallery: {
    hero: { eyebrow: 'गैलरी', title: 'तस्वीरों में हमारा काम', subtitle: 'हमारे स्वयंसेवकों और समुदायों को कार्य करते हुए देखें।' },
    women: { title: 'महिला सुरक्षा और सशक्तिकरण', caption: 'कार्यशालाएं, आउटरीच और पीड़ित सहायता सत्र।' },
    tree: { title: 'वृक्षारोपण अभियान', caption: 'मोहल्लों में सामुदायिक वृक्षारोपण दिवस।' },
    animal: { title: 'पशु बचाव', caption: 'बचाव, उपचार और गोद लेने की कहानियां।' },
    clean: { title: 'सफाई अभियान', caption: 'स्वयंसेवक सार्वजनिक स्थानों को कूड़ा-मुक्त रखते हुए।' },
    note: '📸 किसी हालिया अभियान या कार्यक्रम की तस्वीरें हैं? हमें भेजें, हम उन्हें यहाँ दिखाएंगे।',
  },
  donate: {
    hero: { eyebrow: 'दान करें', title: 'आपका सहयोग असली, जमीनी काम को सहारा देता है', subtitle: 'आपका हर योगदान किसी पशु को बचाने, पेड़ लगाने, किसी पीड़िता की मदद करने या मोहल्ला साफ करने में मदद करता है।' },
    disabled: {
      title: 'ऑनलाइन दान जल्द शुरू हो रहा है',
      text: 'हम सुरक्षित ऑनलाइन भुगतान की व्यवस्था कर रहे हैं। तब तक, कृपया सीधे हमसे संपर्क करें — हमारी टीम आपकी सहायता करेगी।',
      contactBtn: 'संपर्क करें',
    },
  },
  contact: {
    hero: { eyebrow: 'संपर्क करें', title: 'आइए साथ मिलकर काम करें', subtitle: 'सवाल हों, साझेदारी करनी हो, या स्वयंसेवा के लिए तैयार हों — हमें आपसे सुनकर खुशी होगी।' },
    info: { title: 'सीधे हमसे संपर्क करें' },
    volunteerInterests: {
      title: 'स्वयंसेवा में रुचि',
      women: 'महिला सुरक्षा', animals: 'पशु बचाव', trees: 'वृक्षारोपण', clean: 'शहर की सफाई', advocacy: 'वकालत',
    },
    form: {
      title: 'संदेश भेजें',
      namePh: 'नाम', emailPh: 'ईमेल', interestPh: 'मुझे रुचि है…',
      messagePh: 'संदेश (जैसे, मैं वृक्षारोपण अभियान में स्वयंसेवा करना चाहता/चाहती हूं)',
      submit: 'संदेश भेजें',
      other: 'कुछ और',
    },
    thanks: { title: 'संदेश प्राप्त हुआ!', text: 'संपर्क करने के लिए धन्यवाद — हमारी टीम जल्द ही आपसे संपर्क करेगी।' },
  },
  news: {
    hero: { eyebrow: 'समाचार और कार्यक्रम', title: 'हम हाल ही में क्या कर रहे हैं', subtitle: 'हाल की गतिविधियां और जुड़ने के आगामी अवसर।', note: '(नमूना प्रविष्टियां — इन्हें अपने वास्तविक अपडेट से बदलें।)' },
    latestHead: 'हाल की गतिविधियां',
    upcomingHead: 'आगामी कार्यक्रम',
    l1: { date: 'अगस्त 2026', title: 'लैंगिक समानता आउटरीच सत्र', text: 'महिलाओं के अधिकारों और कार्यस्थल समानता पर एक सामुदायिक कार्यशाला।' },
    l2: { date: 'जुलाई 2026', title: 'सामुदायिक पशु बचाव अभियान', text: 'स्वयंसेवकों ने सड़क के पशुओं के उपचार और आश्रय में सहायता की।' },
    l3: { date: 'जून 2026', title: 'मोहल्ला सफाई दिवस', text: 'स्थानीय स्वयंसेवकों ने कूड़ा-संग्रहण और जागरूकता अभियान चलाया।' },
    u1: { date: 'अक्टूबर 2026', title: 'महिला सुरक्षा कार्यशाला', text: 'स्थानीय महिलाओं और लड़कियों के लिए जागरूकता व आत्मरक्षा सत्र।' },
    u2: { date: 'नवंबर 2026', title: 'वृक्षारोपण अभियान', text: 'सामुदायिक वृक्षारोपण कार्यक्रम — स्वयंसेवकों का स्वागत है।' },
    u3: { date: 'दिसंबर 2026', title: 'पशु गोद लेने का मेला', text: 'प्यार भरे घर के लिए तैयार बचाए गए पशुओं से मिलें।' },
    u4: { date: 'जनवरी 2027', title: 'शहर सफाई दिवस', text: 'एक बड़े मोहल्ला-स्तरीय सफाई अभियान में हमारे साथ जुड़ें।' },
  },
};
